import { MICROCERTIFICATE_MINIMUM_PROGRESS } from './constants';

export const shouldNotificateForNewMicrocertificate = (
  oldProgress: number,
  updatedProgress: number,
): boolean =>
  oldProgress < MICROCERTIFICATE_MINIMUM_PROGRESS &&
  updatedProgress >= MICROCERTIFICATE_MINIMUM_PROGRESS;
